// @flow

import {
  call,
  put,
} from 'redux-saga/effects'

import {getCurrentPosition} from '../lib/getCurrentPosition'
import {mapActions} from '../actions'

import {moveMapByLocation} from './moveMapByLocation'
import {locationToPointLocation} from '../lib/locationToPointLocation'
import {googleMapApi} from '../../../google-map'
import {loadServiceProvidersFromLocation} from './loadServiceProvidersFromLocation'

export function* ensureCurrentLocation():Effect {
  const location:Location = yield call(getCurrentPosition)
  yield put(mapActions.setLocation(location))
  const map:GoogleMap = yield call(moveMapByLocation, location)
  const pointLocation:string = yield call(locationToPointLocation, location)
  const serviceProviders: ServiceProvider[] = yield call(loadServiceProvidersFromLocation, pointLocation)
  yield call(googleMapApi.makeMapMarkers, map, serviceProviders, '/images/marker.png')
}